import { render, staticRenderFns } from "./MyBank.vue?vue&type=template&id=a33b2f8a&scoped=true"
import script from "./MyBank.vue?vue&type=script&lang=js"
export * from "./MyBank.vue?vue&type=script&lang=js"
import style0 from "./MyBank.vue?vue&type=style&index=0&id=a33b2f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33b2f8a",
  null
  
)

export default component.exports